/** The browser tab title: the page's own name first, the app last ("Festival – stageplottter", OIL-264). */
export function pageTitle(...parts: readonly (string | null | undefined)[]): string {
  return [...parts.map((p) => p?.trim() ?? '').filter((p) => p !== ''), 'stageplottter'].join(
    ' – ',
  );
}
